/* eslint-disable no-console */
import { invoke, addListener, removeListener } from '@yoda/bridge'
const env = process.env.CODE_ENV || process.env.NODE_ENV || 'production'
const TOKENURL_BASEURL =
  env === 'production'
    ? `https://feedback.kuai-ying.com`
    : `https://km-feedback.staging.kuaishou.com`

class M2uBridge {
  __yoda__ = null
  /** 销毁队列
   * @type {Function[]}
   */
  __destoryQueue__ = []

  get $yoda() {
    if (!this.__yoda__) {
      throw new Error(`请先使用\`m2uBridge.init\`方法进行初始化`)
    }
    return this.__yoda__
  }

  /**
   *
   * @param {any} yoda yoda 容器实例
   *
   */
  init(yoda = null) {
    this.__yoda__ = yoda
  }

  /** 销毁处理 */
  destroy() {
    while (this.__destoryQueue__?.length) {
      const fn = this.__destoryQueue__?.shift?.()
      fn?.()
    }
  }

  /** bridge 打开系统相册上传图片和视频
   *
   * @typedef {{result:number;type:string;width:number;height:number;token:string}} UploadInfo
   *
   * @param {Object} [options={}]
   * @param {(data:{progress:number})=>void} options.onProgress 上传进度监听
   * @param {(data:UploadInfo)=>void} options.onResult 上传完成监听
   *
   * @returns {Promise<UploadInfo[]>}
   */
  selectFileAndUpload({ onProgress, onResult } = {}) {
    const result = []
    if (typeof onProgress === 'function') {
      addListener('m2u.selectFileAndUploadProgress', onProgress)
      this.__destoryQueue__.push(() => {
        removeListener('m2u.selectFileAndUploadProgress', onProgress)
      })
    }
    const handleResult = (...args) => {
      const [data] = args
      result.push(data)
      if (typeof onResult === 'function') onResult(...args)
    }
    addListener('m2u.selectFileAndUploadResult', handleResult)
    this.__destoryQueue__.push(() => {
      removeListener('m2u.selectFileAndUploadResult', handleResult)
    })
    console.log(
      'TOKENURL_BASEURL==',
      TOKENURL_BASEURL,
      process.env.CODE_ENV,
      process.env.NODE_ENV,
      env
    )
    return invoke('m2u.selectFileAndUpload', {
      arguments: {
        tokenUrl: `${TOKENURL_BASEURL}/rest/n/fb/app/dialog/getToken`,
      },
    })?.then((data) => {
      console.log('bridge【selectFileAndUpload】返回数据：', data, result)
      // eslint-disable-next-line prefer-promise-reject-errors
      // if (data.result !== 1) return Promise.reject([])
      // console.log('【selectFileAndUpload】成功', result)
      return result
    })
  }

  /** bridge 获取用户登录信息
   * @typedef {{head_url: string; pass_token: string; user_id: string; user_name: string}} LoginInfo
   *
   * @returns {Promise<{result:number;data: LoginInfo,message:string}>}
   */
  getLoginStatus() {
    return invoke('m2u.getLoginStatus')
  }

  /** bridge 打开schema链接
   *
   * @param {string} schema 要打开的schema链接
   *
   * @returns {Promise<{result:number}>}
   */
  loadUrlOnNewPage(schema) {
    return invoke('m2u.loadUrlOnNewPage', { url: schema })
  }
}

export const m2uBridge = new M2uBridge()
